import CategoriesTable from './CategoriesTable'

export default CategoriesTable



// WEBPACK FOOTER //
// ./src/components/ChannelTabs/HWTab/MappingTabs/CategoriesTab/CategoriesTable/index.js